export default __webpack_public_path__ + "static/media/logo-app2m.fb7180a2.svg";